import React, { useMemo, useState } from "react";
import { Input } from "antd";
import { ProfileInputWrapper, Label } from "./styles";
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
interface ProfileInputProps {
    label: string;
    type?: string;
    placeholder: string;
    name?: string;
    value?: string;
    disabled?: boolean;
    rules?: any[];
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    suffix?: React.ReactNode;
}

const ProfileInput: React.FC<ProfileInputProps> = ({ label, type = "text", placeholder, value, disabled, onChange, suffix, rules, name }) => {
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);

    const togglePasswordVisibility = () => {
        setIsPasswordVisible(!isPasswordVisible);
    };

    const inputType = useMemo(() => (type === "password" ? (isPasswordVisible ? "text" : "password") : type), [isPasswordVisible, type]);

    return (
        <ProfileInputWrapper type={type} label={<Label>{label}</Label>} rules={rules} name={name}>
            <Input
                type={inputType}
                placeholder={placeholder}
                value={value}
                disabled={disabled}
                onChange={onChange}
                suffix={
                    type === "password" ? (
                        <span onClick={togglePasswordVisibility} style={{ cursor: "pointer" }}>
                            {isPasswordVisible ? <EyeOutlined /> : <EyeInvisibleOutlined />}
                        </span>
                    ) : (
                        suffix
                    )
                }
            />
        </ProfileInputWrapper>
    );
};

export default ProfileInput;
